import axios from "axios";

export const state = {
    reportloanperproducts: [],
};

export const getters = {
    reportloanperproducts: state => state.reportloanperproducts,
};

export const mutations = {
    setReportLoansPerProduct(reportloanperproducts, newValue) { state.reportloanperproducts = newValue},
};

export const actions = {
    async fetchReportLoansPerProduct({ commit }) {
        await axios.get('/reportloanperproducts').then(res => {
            commit('setReportLoansPerProduct', res.data.loans)
        })
    },
    async filterReportLoansPerProduct({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportloanperproducts";
        await axios.post(url, formData).then((response) => {
            commit('setReportLoansPerProduct', response.data.loans)
        })
    },
};
